/* src/app/components/shared/model/allow-cvv/allow-cvv.component.scss */
.allowCvvModel-dialog {
  height: auto;
}
.allowCvvModel-dialog .p-16 {
  padding: 16px !important;
}
.allowCvvModel-dialog .p-r-l-16 {
  padding: 0px 16px;
}
.allowCvvModel-dialog .f-s-25 {
  font-size: 25px;
}
.allowCvvModel-dialog .cvv-footer-sample {
  width: 100%;
  text-align: right;
  border-top: 1px solid #d0d0d0;
}
.allowCvvModel-dialog .ds-sub-heading {
  color: #000;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}
.allowCvvModel-dialog .cvv-content {
  padding: 25px 20px 10px 20px;
}
.allowCvvModel-dialog .clone-card-header {
  border-bottom: 1px solid #d0d0d0;
  background-color: white;
  padding: 12px 16px;
  position: relative;
}
.allowCvvModel-dialog .clone-card-title {
  margin-left: 1px !important;
  color: hsl(0, 0%, 0%);
  font-size: 20px;
  display: inline-block;
  width: 84%;
  padding-top: 8px;
  padding-bottom: 8px;
}
.allowCvvModel-dialog .form-group .form-control {
  padding-left: 15px;
  border-radius: 5px !important;
  border: 1px solid #cfcfcf !important;
}
.allowCvvModel-dialog .card-design {
  width: 200px;
}
.allowCvvModel-dialog .cvv-content input[type=text] {
  margin-top: 0;
  padding-top: 2px;
  padding-bottom: 1px;
  padding-left: 2px;
  padding-right: 2px;
  border: 1px solid #ddd;
  line-height: 26px;
  height: 30px;
  border-radius: 3px;
  border-style: solid;
  width: 100%;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.allowCvvModel-dialog .cvv-content input[type=text]:focus {
  border-color: #66afe9;
  outline: 0;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.allowCvvModel-dialog .text-uppercase {
  text-transform: uppercase !important;
}
::ng-deep .allowCvvModel-dialog .mat-mdc-dialog-container {
  margin: 0px;
  padding: 0px !important;
}
.close-button {
  float: right;
  top: -24px;
  right: -24px;
}
.close-icon {
  transition: 1s ease-in-out;
}
.close-icon:hover {
  transform: rotate(180deg);
}
::ng-deep .allowCvvModel-dialog .close-button {
  float: right;
  top: -52px;
  right: -52px;
}
::ng-deep .allowCvvModel-dialog .mat-mdc-dialog-container {
  overflow: unset;
}
::ng-deep .allowCvvModel-dialog .mat-mdc-dialog-actions {
  margin-bottom: 0px !important;
}
/*# sourceMappingURL=allow-cvv.component.css.map */
